export default __webpack_public_path__ + "static/media/weezly-log.25996fb6.svg";